module.exports = __webpack_public_path__ + "media/smoke.a99b77e8.mp4";